import React from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape } from "react-intl";
import messages from "components/messagesDescription";
import { Link } from "react-router-dom";
import { Button } from "cxa-components";

const InsuranceAdvertisement = ({ data = {}, intl }) => {
  const { advertisementList = [] } = data;

  if (advertisementList.length === 0) {
    return null;
  }
  return (
    <article key={"insuranceAds"} className="card">
      <header>
        <h2>{intl.formatMessage(messages.usefulProductsForYou)}</h2>
      </header>
      {advertisementList.map((item, idx) => (
        <section key={idx}>
          <article className="promo promo--alternate">
            <figure>
              <img alt="" src={item.imageURL} />
            </figure>
            <aside>
              <strong
                dangerouslySetInnerHTML={{
                    __html: item.title
                }}/>
              <p
                dangerouslySetInnerHTML={{
                    __html: item.description
                }}/>
              <p>
                <Button primary href={item.productURL} target="_blank" rel="noopener noreferrer">
                  {intl.formatMessage(messages.findOutMore)}
                </Button>
              </p>
            </aside>
          </article>
        </section>
      ))}
    </article>
  );
};

InsuranceAdvertisement.propTypes = {
  intl: intlShape.isRequired,
  data: PropTypes.object,
};

export default injectIntl(InsuranceAdvertisement);



// WEBPACK FOOTER //
// ./components/dashboard/widgets/InsuranceAdvertisement.js